module.exports = __webpack_public_path__ + "static/media/research_01@3x.bfda91e3.png";